
import grc from '../../assets/images/GRC_preview.png';
function ProductCaption({captionName,captionColor}){
    return(
        <div className="text-center" style={{height:'120px',backgroundColor:captionColor}}>

            <h4 className="text-white pt-4">{captionName}</h4>
            <div className="position-relative">
            <img src={grc} alt="GRC" style={{width:'70px'}} />
            </div>
        </div> 
    )
}
export default ProductCaption;
